import React from 'react';

import { NavLinkButton, ButtonGroup } from '@shared/components/bootstrap';

import { thirdPartyTransferNewURL } from '@admin/config/routes';

export const ThirdPartyTransferNewButton: React.FC<{ accountID: string }> = ({ accountID }) => (
  <>
    <ButtonGroup>
      <NavLinkButton kind="primary" to={thirdPartyTransferNewURL(accountID)}>
        New
      </NavLinkButton>
    </ButtonGroup>
  </>
);
